<form
    #form
    fsForm
    [submit]="save"
    *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <div class="fs-column">
      <h2>
        Please enter the main contact's email and phone number for the  organization
      </h2>
      <mat-form-field class="full-width">
        <mat-label>
          Email
        </mat-label>
        <input
          matInput
          [(ngModel)]="environmentCreate.email"
          fsFormRequired
          fsFormEmail
          name="email">
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>
          Phone Number
        </mat-label>
        <input
          matInput
          [(ngModel)]="environmentCreate.phone"
          fsPhoneField
          name="phone">
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
        type="submit"
        mat-flat-button
        color="primary"
        class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>